import { Box, Button, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Color,
  EduPostTypes,
  FontStyle,
  JobDisplays,
  Slug,
  SurveyButtonStyle,
} from "../../constants";
import { loadedYtScript } from "../../utils/actionUtils";
import { JobDownloads } from "../../utils/jobUtils";
import JobResourceVid from "../JobPanels/JobResourceVid";
import { ResourceContainer, ResourceHeader } from "../JobPanels/ResourcePanel";
import EduAvatar, { authorMap } from "./EduAvatar";

const CTAs = [
  "GET STARTED",
  "LET'S GO",
  "LEVEL UP YOUR APPLICATION",
  "LEARN FROM THE BEST",
];

const ShortTextPanel = ({ data, idx, setIdx, logClick }) => {
  const {
    eduId,
    title,
    subtitle,
    description,
    tags,
    lastElement,
    showIdx,
    author,
    download_name,
  } = data;
  // console.log("data", data);
  const [hovered, setHovered] = React.useState(false);
  return (
    <ResourceContainer fullHeight={false} setHover={setHovered}>
      <EduAvatar
        idx={authorMap[author] ? authorMap[author] : 0}
        enlarge={hovered}
      />
      <ResourceHeader title={title} subtitle={subtitle} />
      <Button
        sx={{
          // ...SurveyButtonStyle.defaultStyling,
          ...SurveyButtonStyle.yellowColor,
          // ...SurveyButtonStyle.gradientColor,
          // textTransform: "none",
          // fontWeight: "normal",
        }}
        disableRipple
        fullWidth
        onClick={() => {
          setIdx(idx);
          logClick({ clickType: "txt", clickId: eduId });
        }}>
        {download_name && JobDownloads[download_name] !== undefined
          ? JobDownloads[download_name].shortName
            ? JobDownloads[download_name].shortName
            : JobDownloads[download_name].name
          : CTAs[idx % CTAs.length]}
      </Button>
    </ResourceContainer>
  );
};

export default ShortTextPanel;
